import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AlignHorizontalCenterIcon(props: IconProps) {
    return <Icon {...props} iconKey={"align_horizontal_center"}/>
}
